import React, { Fragment } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { ModalBackDrop } from "static/styled/ModalBackDrop.styled";
import ReadingChallengeCreator from "@c/reading-challenge-view/reading-challenge-creator/ReadingChallengeCreator";

export const Routes = function({ location }) {
  return (
    <Switch location={location}>
      <Route
        path="/reading-challenge/edit/:id"
        render={props => (
          <Fragment>
            <ReadingChallengeCreator {...props} />
            <ModalBackDrop active second />
          </Fragment>
        )}
      />
    </Switch>
  );
};

export default withRouter(Routes);
